module.exports = __webpack_public_path__ + "img/logo-w.65dabd64.png";